import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import useAxios from "../../sections/useAxios";
import { registerSchema } from "../../validations/validation-schemas";

const RegisterUserModal = ({ isOpen, toggle }) => {
  const api = useAxios();

  const mutation = useMutation(
    async (values) => {
      return api.post("accounts/register", values);
    },
    {
      onSuccess: (data) => {
        toast.success(
          data?.data?.message
        );
        toggle();
      },
      onError: (err) => {
        toast.error(err?.response?.data?.message || "Registration failed");
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      user_type: "",
      company: "",
      location: "",
    },
    validationSchema: registerSchema,
    onSubmit: (values) => {
      let payload = {
        name: values.name,
        email: values.email,
        user_type: values.user_type,
      };

      if (values.user_type === "investor") {
        payload.investor_company = values.company;
      }

      if (values.user_type === "company") {
        payload.location = values.location;
      }
      mutation.mutate(payload);
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={() => { toggle(); formik.resetForm() }} onClosed={() => { toggle(); formik.resetForm() }}>
      <ModalHeader toggle={toggle}>
        Register User
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={formik.handleSubmit}>
          <FormGroup>
            <Label>Name</Label>
            <Input
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.name && !!formik.errors.name}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="text-danger">{formik.errors.name}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label>Email</Label>
            <Input
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.email && !!formik.errors.email}
            />
            {formik.touched.email && formik.errors.email && (
              <div className="text-danger">{formik.errors.email}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label>User Type</Label>
            <Input
              type="select"
              name="user_type"
              value={formik.values.user_type}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.user_type && !!formik.errors.user_type}
            >
              <option value="">Select User Type</option>
              <option value="investor">Investor</option>
              <option value="company">Company</option>
            </Input>
            {formik.touched.user_type && formik.errors.user_type && (
              <div className="text-danger">{formik.errors.user_type}</div>
            )}
          </FormGroup>

          {formik.values.user_type === "investor" ? (
            <FormGroup>
              <Label>Company</Label>
              <Input
                name="company"
                value={formik.values.company}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.company && !!formik.errors.company}
              />
              {formik.touched.company && formik.errors.company && (
                <div className="text-danger">{formik.errors.company}</div>
              )}
            </FormGroup>
          ) : formik.values.user_type === "company" && (
            <FormGroup>
              <Label>Location</Label>
              <Input
                name="location"
                value={formik.values.location}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.location && !!formik.errors.location}
              />
              {formik.touched.location && formik.errors.location && (
                <div className="text-danger">{formik.errors.location}</div>
              )}
            </FormGroup>
          )}

          <div className="d-flex justify-content-end">
            <Button type="submit" className="primary-bg text-white primary-hover" disabled={mutation.isLoading}>
              {mutation.isLoading ? <Spinner size="sm" /> : "Register"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default RegisterUserModal;
